import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  campaignId: z.string().uuid().optional(),
  runId: z.string().uuid().optional(),
});

export const Route = createFileRoute("/dashboard/marketing/email-campaigns")({
  beforeLoad: requirePermissionGuard("hca.email_serialy.write"),
  validateSearch: (search) => searchSchema.parse(search),
});
